import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/vercel/path0/src/views/components/_shadcn-ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/views/components/atoms/blur-fade-text/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/views/components/atoms/blur-fade/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/views/components/molecules/cards/education-card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/views/components/molecules/cards/experience-card/index.tsx");
